var e = function e(_e) {
  return parseFloat(_e);
};

export default function (r) {
  return null == r && (r = r), function (n, t, i, f) {
    null == i && (i = r), null == f && (f = i);
    var l = String(n).match(/[\d.\-\+]*\s*(.*)/)[1] || "";
    if (l === t) return n;
    var u = e(n);
    if ("px" !== l) if ("em" === l) u = e(n) * e(i);else if ("rem" === l) u = e(n) * e(r);else {
      if ("ex" !== l) return n;
      u = e(n) * e(i) * 2;
    }
    var a = u;
    if ("px" !== t) if ("em" === t) a = u / e(f);else if ("rem" === t) a = u / e(r);else {
      if ("ex" !== t) return n;
      a = u / e(f) / 2;
    }
    return parseFloat(a.toFixed(5)) + t;
  };
}